import Vue from "vue";
import Router from "vue-router";
import Auth from "./helpers/middleware";

/* ---- [VISTAS] ----- */

//User Account
import Cuenta from "./views/account/index";

//TI
import Usuarios from "./views/ti/usuarios/index";
import Callconnect from "./views/ti/callconnect/index";
import Access from "./views/ti/access/index";
import Sistemas from "./views/ti/systems/index";
import Ausencias from "./views/ti/ausencias/index";
import Departments from "./views/ti/departamentos/index";
import Menus from "./views/ti/departamentos/menus";

//Operaciones
import Baneados from "./views/operaciones/baneados/index";
import Opciones from "./views/operaciones/opciones/index";
import Clasifications from "./views/operaciones/clasificaciones/index";
import RCestadisticas from "./views/operaciones/clasificaciones/estadisticas/index";
import RCAdmin from "./views/operaciones/clasificaciones/admin/index";
import createModelWhiteList from "./views/operaciones/listablanca/modelos/index";
import RemoveGhost from "./views/operaciones/avisos/fantasmas/index";
import HistoricalAdverts from "./views/operaciones/avisos/historicos/index";
import GestionAutomotoras from "./views/operaciones/automotoras/index";
import Badges from "./views/operaciones/badges/index";
import CPMigration from './views/operaciones/cp-migration/index';

import PlanesProductos from "./views/operaciones/planesproductos/index";
import AsignacionProductos from "./views/operaciones/avisos/asignacion/index";

import CertifiedVehicles from "./views/operaciones/plugins/certified-vehicles";

//Marketing
import Leads from "./views/marketing/campaigns/Leads";
import CreateCampaign from "./views/marketing/campaigns/CreateCampaign";
import CreateDFPForm from "./views/marketing/campaigns/CreateDFPForm";
import LeadsUpload from "./views/marketing/leads/upload";
import FacebookLeads from "./views/marketing/leads/FacebookLeads";

//Finanzas
import Payments from "./views/finance/Payments";
import AutofactPayments from "./views/finance/AutofactPayments/";
import DestacadosPayments from "./views/finance/DestacadosPayments";
import ClientReportOLD from "./views/finance/ClientReport";
import ClientReport from "./views/finance/ClientStatusReport";

//General
import Home from "./views/home/index";
import Unauthorized from "./views/Errors/Unauthorized";
import p404 from "./views/Errors/p404";

//Login
import Login from "./views/Login/index";
import Clientes from "./views/automotoras/clientes/index";



const BASE_URL = process.env.VUE_APP_BASE_URL;

Vue.use(Router);

const routerIn = [{
        path: "*",
        name: "not-found",
        component: p404
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            layout: "login"
        }
    },
    {
        path: "/cuenta",
        name: "account",
        component: Cuenta,
        meta: {
            logged: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/usuarios",
        name: "users",
        component: Usuarios,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/accesos",
        name: "access",
        component: Access,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/callconnect",
        name: "callconnect",
        component: Callconnect,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/sistemas",
        name: "systems",
        component: Sistemas,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/ausencias",
        name: "ausencias",
        component: Ausencias,
        meta: {
            //authRequired: true,
            logged: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/departamentos/",
        name: "alldepartamentos",
        component: Departments,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/tinformacion/departamentos/menus",
        name: "menus",
        component: Menus,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/automotoras/usuarios",
        name: "usersA",
        component: Usuarios,
        meta: {
            authRequired: true,
            layout: "default",
            filter: [{
                path: "/automotoras/usuarios",
                sistema: 2
            }]
        }
    },
    {
        path: "/operaciones/baneados",
        name: "baneados",
        component: Baneados,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/automotoras/:id",
        name: "gestionAutomotorasID",
        component: GestionAutomotoras,
        meta: {
            login: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/planes-productos",
        name: "planesProductos",
        component: PlanesProductos,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/avisos/asignacion-productos",
        name: "asignacionProductos",
        component: AsignacionProductos,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/automotoras",
        name: "gestionAutomotoras",
        component: GestionAutomotoras,
        meta: {
            login: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/avisos/eliminar-fantasmas",
        name: "removeGhost",
        component: RemoveGhost,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/avisos/historicos",
        name: "historicalAdverts",
        component: HistoricalAdverts,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/listablanca/crea-modelo",
        name: "createModelWhiteList",
        component: createModelWhiteList,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/operaciones/opciones",
        name: "options",
        component: Opciones,
        meta: {
            authRequired: true
        }
    },
    {
        path: "/operaciones/registro-civil/asociaciones",
        name: "clasifications",
        component: Clasifications,
        meta: {
            authRequired: true
        }
    },
    {
        path: "/operaciones/registro-civil/administracion",
        name: "rcadmin",
        component: RCAdmin,
        meta: {
            authRequired: true
        }
    },
    {
        path: "/operaciones/registro-civil/estadisticas",
        name: "rcestadisticas",
        component: RCestadisticas,
        meta: {
            logged: true
        }
    },
    {
        path: "/operaciones/badges",
        name: "badges",
        component: Badges,
        meta: {
            authRequired: true,
            layout: "default"  
        }
    },
    {
        path: "/operaciones/cp-migraciones",
        name: "cp-migrations",
        component: CPMigration,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/marketing/leads",
        name: "leads",
        component: Leads,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/marketing/crear/campana",
        name: "createCampaign",
        component: CreateCampaign,
        meta: {
            logged: true,
            layout: "default"
        }
    },
    {
        path: "/marketing/crear/formulario",
        name: "createDFPForm",
        component: CreateDFPForm,
        meta: {
            logged: true,
            layout: "default"
        }
    },
    {
        path: "/marketing/leads/cargar-excel",
        name: "leadsUpload",
        component: LeadsUpload,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/marketing/leads/facebook-leads",
        name: "FacebookLeads",
        component: FacebookLeads,
        meta: {
            authRequired: true,
            logged: true,
            layout: "default"
        }
    },
    {
        path: "/finanzas/pagos",
        name: "payments",
        component: Payments,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/finanzas/pagos-autofact",
        name: "autofactPayments",
        component: AutofactPayments,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/finanzas/pagos-destacados",
        name: "destacadosPayments",
        component: DestacadosPayments,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/finanzas/reporte-clientes",
        name: "clientReport",
        component: ClientReport,
        meta: {
            authRequired: true,
            layout: "default"
        }
    },
    {
        path: "/no-autorizado",
        name: "unauthorized",
        component: Unauthorized
    },
    {
        path: "/home",
        name: "launchpad",
        alias: ["/", "launchpad"],
        component: Home,
        meta: {
            logged: true
        }
    },
    {
        path: "/:slug",
        name: "launchpadslug",
        component: Cuenta
    },
    {
        path: "/automotoras/clientes",
        name: "clients",
        component: Clientes,
        meta: {
            authRequired: true
        }
    },
    {
        path: "/operaciones/plugins/certified-vehicles",
        name: "CertifiedVehicles",
        component: CertifiedVehicles,
        meta: {
            //authRequired: true,
            logged: true,
            layout: "default"
        }
    }
];

export const router = new Router({
    mode: "history",
    base: BASE_URL,
    routes: routerIn
});

try {
    router.beforeEach((to, from, next) => {
        const loggedIn = Auth.logged();
        if (Auth.sessionExpiration()) {
            Auth.logOut(true);
        } else if (!loggedIn) {
            if (to.name == "login") {
                next();
                return false;
            } else {
                next({
                    name: "login"
                });
                return false;
            }
        } else if (to.name == "login") {
            next({
                name: "launchpad"
            });
            return false;
        } else {
            const authRequired = Auth.mapAccess(to.name);

            if (to.meta.logged) {
                next();
                return false;
            } else if (!authRequired && to.meta.authRequired) {
                next({
                    name: "unauthorized"
                });
                return false;
            }
            next();
            /* if (!authRequired && to.meta.authRequired) {
              next({ name: 'unauthorized' });
              return false;
            }  */
        }
    });
} catch (e) {
    router.push("error");
}